import React, { useState } from "react";
import { useAuth } from "../lib/auth";
import { useNavigate } from "react-router-dom";
import { Wrench, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [username, setU] = useState("");
  const [password, setP] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(username, password);
      toast.success("Signed in");
      nav("/", { replace: true });
    } catch (e) {
      setErr(e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen blueprint-grid flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Brand */}
        <div className="mb-8 flex items-center gap-3">
          <div className="h-10 w-10 border border-red-500/60 bg-red-500/10 flex items-center justify-center">
            <Wrench className="h-5 w-5 text-red-400" />
          </div>
          <div>
            <div className="text-lg font-semibold tracking-tight">Morgan Shop Tracker</div>
            <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">Cloud Edition · Restricted Access</div>
          </div>
        </div>

        <form onSubmit={submit} className="border border-zinc-800 bg-zinc-950/80 p-6 space-y-5" data-testid="login-form">
          <div>
            <label className="text-xs font-mono uppercase tracking-[0.1em] text-zinc-400 block mb-2">Username or Email</label>
            <input
              autoFocus
              value={username} onChange={(e) => setU(e.target.value)}
              data-testid="login-username"
              placeholder="myles or myles@morgancontractors.com"
              className="w-full bg-zinc-900 border border-zinc-800 focus:border-red-500 focus:ring-2 focus:ring-red-500/30 rounded-sm px-3 py-2 font-mono text-sm outline-none transition-colors"
              autoComplete="username"
            />
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-[0.1em] text-zinc-400 block mb-2">Password</label>
            <input
              type="password"
              value={password} onChange={(e) => setP(e.target.value)}
              data-testid="login-password"
              className="w-full bg-zinc-900 border border-zinc-800 focus:border-red-500 focus:ring-2 focus:ring-red-500/30 rounded-sm px-3 py-2 font-mono text-sm outline-none transition-colors"
              autoComplete="current-password"
            />
          </div>
          {err && <div data-testid="login-error" className="text-sm text-red-400 border border-red-500/30 bg-red-500/10 px-3 py-2 rounded-sm">{err}</div>}
          <button
            type="submit" disabled={busy}
            data-testid="login-submit"
            className="w-full bg-red-600 hover:bg-red-500 disabled:opacity-50 text-white font-medium py-2 rounded-sm transition-colors flex items-center justify-center gap-2"
          >
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            Sign In
          </button>

          <div className="pt-4 border-t border-zinc-800 text-[11px] font-mono text-zinc-500 leading-relaxed">
            Invite-only. Contact your admin to receive an invite link.<br/>
            Default admin: <span className="text-zinc-300">myles</span> · check with your account owner for password.
          </div>
        </form>
      </div>
    </div>
  );
}
